import React from 'react';
import { cn } from '../utils';

interface ElegantGradientBackgroundProps {
  children?: React.ReactNode;
  className?: string;
  containerClassName?: string;
}

export const ElegantGradientBackground = ({
  children,
  className,
  containerClassName,
}: ElegantGradientBackgroundProps) => {
  return (
    <div
      className={cn(
        "relative h-full min-h-screen w-full bg-[var(--surface)] overflow-hidden transition-bg",
        containerClassName
      )}
    >
      <div
        className={cn(
          "absolute inset-0 opacity-40 pointer-events-none",
          className
        )}
        // Wide, soft radial falloffs give the glow without a full-screen blur filter or
        // blend mode — both are re-composited on every animation frame above them.
        style={{
          background: `
            radial-gradient(ellipse 60% 70% at 15% 50%, color-mix(in srgb, var(--primitive-ember-400) 15%, transparent), transparent 70%),
            radial-gradient(ellipse 55% 60% at 85% 30%, color-mix(in srgb, var(--primitive-gold-400) 15%, transparent), transparent 70%)
          `,
        }}
      />
      <div className="relative z-10 w-full h-full">
        {children}
      </div>
    </div>
  );
};
